/*application status body*/

import React, { useState, useEffect } from "react";
import { Button, Typography } from "antd";
import {
  ExclamationCircleFilled,
} from "@ant-design/icons";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import loadingGif from "./loading.gif";
import message from "./message.gif";
import "./ApplicationStatusBody.css";
import mixpanel from "mixpanel-browser";

const { Text } = Typography;

const click_action_map = {
  219: "bajaj_form_application",
  207: "sbi_form_application",
  197: "scb_form_application",
}

// const screen_view_map = {
//   219: "bajaj_form_popup",
//   207: "sbi_form_popup",
//   197: "scb_form_popup",
// }

const ApplicationStatusIcon = ({Icon}) => {
  if(Icon.toLowerCase() ==  "tick"){
     return(<CheckCircleRoundedIcon
    className="ICON"
      style={{color: "#00BA00", height: 80 , width:80}}
    />
  );
} else if(Icon.toLowerCase() == "cross" ){
  return (<CancelRoundedIcon
      className="ICON"
      style={{ color: "#FF0000",height: 80 , width:80 }}
    />
  );
} else if(Icon.toLowerCase() == "exclamation") {
  return (<ExclamationCircleFilled
      className="ICON"
      style={{  color: "#EC8E00"  }}
    />
  );
} else if(Icon.toLowerCase() == "grey_exclamation"  ||
    Icon.toLowerCase() == "greyExclamation"){
      return (<ExclamationCircleFilled
      className="ICON"
      style={{ color: "#928E8E" }}
    />
  );
} else if(Icon.toLowerCase() == "loading") {
     return (<img 
      src={loadingGif} 
      alt="loading..." 
      className="Image"
      />
  );
} else if(Icon.toLowerCase() == "message"){
    return (<img 
      src={message} 
      alt="loading..." 
      className="Image" 
      />
  );
} else{ 
  return null ;
}
};


const ApplicationStatusBody = ({
  applicationStatus,
  editApplicationForm,
  retryApplication,
  partner,
  phoneNumber,
}) => {

  // useEffect(() => {
  //   mixpanel.track("screen_view", {
  //     screen_name: screen_view_map[partner?.id],
  //     page_name: applicationStatus?.status,
  //     partner_id: partner?.id,
  //     phone_number: phoneNumber,
  //     })
  // },[])



  return (
    <div className="mainContainer">
      <div className="StatusContainer">

        {applicationStatus.icon ? <ApplicationStatusIcon Icon={applicationStatus.icon} /> : null }

        <p className="Status"
          style={{
            color:
              "grey_exclamation" == applicationStatus.icon.toLowerCase() ||
              "greyExclamation" == applicationStatus.icon.toLowerCase()
                ? "#928E8E"
                : "#000000",
          }}
        >
          {applicationStatus.status}
        </p>

        {applicationStatus.message ? (
              <div
                style={{
                  padding: 15,
                  color: "#000000",
                }}
              >
                {applicationStatus.message}
              </div>
            ) : null}

            {applicationStatus.message1 ? (
              <div
                style={{
                  padding: 15,
                  color: "#6C63FF",
                }}
              >
                {applicationStatus.message1}
              </div>
            ) : null}

            {applicationStatus.message2 ? (
              <div
                style={{
                  padding: 15,
                  color: "#000000",
                }}
              >
                {applicationStatus.message2 }
              </div>
            ) : null}

        {applicationStatus.reason ? (
          <div className="ReasonContainer">
            {applicationStatus.reason}
          </div>
        ) : null}

        {applicationStatus.vcipLink ? (
          <Button
            type="primary"
            htmlType="submit"
            block
            className="button"
            onClick={() => {
              window.open(applicationStatus.vcipLink)
              mixpanel.track( "click_action", {
                item_name: click_action_map[partner?.id],
                cta_name: "Continue with Next Step",
                partner_id: partner?.id,
                phone_number: phoneNumber,
              });
            }}
          >
            <Text className="Text">Continue with Next Step</Text>
          </Button>
        ) : null}

        {applicationStatus.isEditAllowed ? (
          <Button
            type="primary"
            htmlType="submit"
            block
            className="button"
            onClick={() => {
              editApplicationForm();
              mixpanel.track( "click_action", {
                item_name: click_action_map[partner?.id],
                cta_name: "Edit Application Form",
                partner_id: partner?.id,
                phone_number: phoneNumber,
              });
            }}
          >
            <Text className="Text">Edit Application Form</Text>
          </Button>
        ) : null}
        {applicationStatus.isRetryAllowed ? (
          <Button
            type="primary"
            htmlType="submit"
            block
            className="button"
            onClick={() => {
              retryApplication();
              mixpanel.track( "click_action", {
                item_name: click_action_map[partner?.id],
                cta_name: "Retry Application Submit",
                partner_id: partner?.id,
                phone_number: phoneNumber,
              });
            }}
          >
            <Text className="Text">Retry Application Submit</Text>
          </Button>
        ) : null}
        <hr
          align="center"
          width="9%"
          color="#6C63FF"
          style={{ marginTop: 15 }}
        />
      </div>
    </div>
  );
};

export default ApplicationStatusBody;
